var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-menu-container" }, [
    _c("div", { staticClass: "sidebar-main-label-grid" }, [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showRenameInput,
              expression: "!showRenameInput"
            }
          ],
          staticClass: "sidebar-main-label collapsable-ellipsis"
        },
        [_vm._v(_vm._s(_vm.nameActiveGroup))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showRenameInput,
            expression: "showRenameInput"
          },
          {
            name: "model",
            rawName: "v-model",
            value: _vm.inputName,
            expression: "inputName"
          }
        ],
        staticClass: "photo-sidebar-rename-project",
        attrs: { type: "text", placeholder: _vm.nameActiveGroup },
        domProps: { value: _vm.inputName },
        on: {
          change: _vm.renameProject,
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.inputName = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "edit-project-name-container",
          on: { click: _vm.showInputRename }
        },
        [_c("SVGEditProjectName")],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-gray-text" }, [
      _vm._v("\n        Выберите цвет группы:\n    ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-colors-pallet" },
      _vm._l(_vm.groupColorsOptions, function(color) {
        return _c(
          "div",
          {
            staticClass: "grid-colors-pallet-element",
            class: {
              "active-grid-colors-pallet-element": color === _vm.activeColor
            },
            on: {
              click: function($event) {
                return _vm.selectGroupColor(color)
              }
            }
          },
          [
            _c("div", {
              staticClass: "color-circle",
              style: { "background-color": color }
            })
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }